// Real campus photographs — Wikimedia Commons (CC licenses), via Special:FilePath redirects.
// Credits: "Doon School 75th Founder's Day - DS75, 2010.jpg", "The Doon School Masters in September 1935.png",
// "Rose Bowl amphitheatre, The Doon School.jpg", "Art School at The Doon School.jpg", "DoonSchoolLibrary.jpg",
// "Main Field at The Doon School, Dehradun, India.jpg", "Oberoi House at The Doon School.jpg",
// "Main Building, Doon School at night by Subhojit Chatterjee.jpg", "Doon School ivy-covered Main Building…",
// "The Main Gate of The Doon School.jpg", "Cricket on the Doon School main field.jpg",
// "The main building … (2011).jpg", "Symphony Orchestra of India at The Doon School, Dehradun.jpg".
const W = (name) => `/campus/${name}`;

export const IMAGES = {
  hero: W("founders-day-75.jpg"),
  mainBuilding: W("main-building.jpg"),
  roseBowl: W("rose-bowl.jpg"),
  library: W("library.jpg"),
  artSchool: W("art-school.jpg"),
  skinners: W("skinners-field.jpg"),
  auditorium: W("auditorium.jpg"),
  masters1935: W("masters-1935.png"),
  ivyMB: W("ivy-main-building.jpg"),
  mainGate: W("main-gate.jpg"),
  cricket: W("cricket.jpg"),
  oberoiHouse: W("oberoi-house.jpg"),
  foundersDay75: W("founders-day-75.jpg"),
};

export const MILESTONES = [
  {
    id: "founding",
    label: "1935",
    title: "The Founding",
    img: IMAGES.masters1935,
    caption: "The first masters — September 1935",
    excerpt: "S.R. Das's dream opens its gates with 61 boys and one audacious vision.",
    body: [
      "On 10 September 1935, Satish Ranjan Das's long-cherished dream took shape in the Doon valley: an all-India, residential school that would bring together boys from every corner of a soon-to-be-independent nation.",
      "Sixty-one boys walked through the gates that first year, led by the school's first Headmaster, Arthur E. Foot, who arrived from Eton with a conviction that Indian boys deserved a school of their own — of India, run in India, for India.",
    ],
    note: "Arthur Foot's founding generation set the tone that still echoes at Chandbagh: plain living, high thinking, and the courage to build something new.",
  },
  {
    id: "rose-bowl",
    label: "The 1930s",
    title: "The Rose Bowl",
    img: IMAGES.roseBowl,
    caption: "The Rose Bowl amphitheatre — an archive view",
    excerpt: "An amphitheatre carved into a natural hollow — Doon's open-air soul.",
    body: [
      "Tucked into a natural depression on the estate, the Rose Bowl became the open-air amphitheatre where every Dosco learns to face an audience — plays, house competitions, and the most anticipated evening of the year: the Founder's Play.",
      "Under the deodars and the open sky, the Bowl has hosted nearly nine decades of drama, applause and monsoon-soaked memories.",
    ],
    note: "Generations of Doscos got their first stage fright — and lost it for good — under the open sky of the Rose Bowl.",
  },
  {
    id: "main-building",
    label: "Landmark",
    title: "The Main Building",
    img: IMAGES.ivyMB,
    caption: "Ivy on the Main Building — Chandbagh",
    excerpt: "The red-brick heart of Chandbagh, looming over the Quad since the beginning.",
    body: [
      "With its colonnaded corridors, clock tower and weather-worn brick, the Main Building is the first thing every visitor sees and the last thing every leaving boy looks back at.",
      "It houses the administrative heart of the school and looks out over the Quad — the stage for assemblies, ceremonies and ninety-one Founder's Day photographs.",
    ],
    note: "Every Founder's Day photograph since 1935 has had the same unmistakable backdrop: the Main Building and its clock tower.",
  },
  {
    id: "1947",
    label: "1947",
    title: "A School for New India",
    img: IMAGES.mainGate,
    caption: "The Main Gate — Chandbagh, Dehradun",
    excerpt: "As India found her feet, Doon's first Old Boys stepped into her service.",
    body: [
      "Barely a dozen years after opening, the school watched its earliest alumni fan out into the professions, the civil services and public life of a newly independent India.",
      "The ideal Arthur Foot had spoken of — boys who would serve the country — became the measuring stick for every batch that followed.",
    ],
    note: "The Doon School Old Boys' Society (DSOBS) grew into one of India's most storied alumni networks — writers, industrialists, soldiers, statesmen.",
  },
  {
    id: "fields",
    label: "Tradition",
    title: "The Playing Fields",
    img: IMAGES.cricket,
    caption: "Cricket on the Main Field — Skinners",
    excerpt: "From Skinners Field to the Sports Complex — sport as a way of life.",
    body: [
      "Doon's founders believed games taught what classrooms could not. Skinners Field and the modern Sports Complex carry that belief forward — athletics finals, cricket, hockey and the roar of inter-house battles.",
      "The annual Inter-House Athletics Finals remain among the loudest afternoons at Chandbagh.",
    ],
    note: "Old Boys went on to the biggest sporting stages of all — including an Olympic gold medal won by shooter Abhinav Bindra.",
  },
  {
    id: "oberoi",
    label: "1991",
    title: "The Fifth House",
    img: IMAGES.oberoiHouse,
    caption: "Oberoi House — opened 1991",
    excerpt: "Oberoi House opens its doors — the newest banner in a four-house sky.",
    body: [
      "For over half a century, Doon life ran through four houses: Hyderabad, Jaipur, Kashmir and Tata. In 1991, during Headmaster Shomie Das's tenure, Oberoi House joined them — a fifth banner and a new chapter for the house system.",
      "Its fete — the legendary Pagal Gymkhana — is now a fixture of Founder's Day itself.",
    ],
    note: "The newest house, carrying the newest energy into the oldest of traditions.",
  },
  {
    id: "jubilee",
    label: "2026",
    title: "The 91st Founder's Day",
    img: IMAGES.foundersDay75,
    caption: "The 75th Founder's Day, 2010 — the 91st comes this October",
    excerpt: "October 22–24, 2026 — Chandbagh opens her gates once more.",
    body: [
      "Ninety-one years after those first sixty-one boys, the whole Doon family returns: Old Boys flying in from across the world, parents on the Quad, and boys on Skinners Field under October light.",
      "Three days of exhibitions, cricket, debate, drama and song — and one more line added to a story that began in 1935.",
    ],
    note: "Knowledge our light — happy 91st Founder's Day, Chandbagh.",
  },
];

export const CATEGORIES = ["All", "Exhibitions", "Sports", "Cultural & Plays", "Old Boys (DSOBS)", "Eats & Stalls"];

export const CATEGORY_COLORS = {
  Exhibitions: "#D4AF37",
  Sports: "#22C55E",
  "Cultural & Plays": "#DC2626",
  "Old Boys (DSOBS)": "#3B82F6",
  "Eats & Stalls": "#F97316",
};

export const DAYS = [
  { id: "1", label: "Day 1", date: "Oct 22, 2026", tag: "Exhibitions & Athletics" },
  { id: "2", label: "Day 2", date: "Oct 23, 2026", tag: "Cricket, Debates & Drama" },
  { id: "3", label: "Day 3", date: "Oct 24, 2026", tag: "Fete, AGM & Farewells" },
];

export const SCHEDULE = [
  { id: "d1-1", day: "1", time: "08:30 AM", title: "Opening Assembly & Flag Hoisting", venue: "Main Building", category: "Cultural & Plays", desc: "The school assembles on the Quad as the tricolour and the school flag rise over the Main Building." },
  { id: "d1-2", day: "1", time: "09:30 AM", title: "Science, Art & Design-Tech Exhibitions", venue: "Kilachand Library", category: "Exhibitions", desc: "Boys' projects across science, art and the design & tech studios, with the archives display in the library." },
  { id: "d1-3", day: "1", time: "11:00 AM", title: "Platinum Walk & Heritage Trail", venue: "Main Building", category: "Old Boys (DSOBS)", desc: "Old Boys process from the Main Building along the heritage trail of the campus they grew up in." },
  { id: "d1-4", day: "1", time: "01:00 PM", title: "Inter-House Athletics Finals", venue: "Skinners Field", category: "Sports", desc: "The loudest afternoon of the year — five houses, one track, and the athletics shield on the line." },
  { id: "d1-5", day: "1", time: "03:30 PM", title: "Art School Open Studios", venue: "Art School", category: "Exhibitions", desc: "The studios throw their doors open: painting, ceramics, printmaking and live portrait sessions." },
  { id: "d1-6", day: "1", time: "05:00 PM", title: "Eats & Stalls Open", venue: "Dining Hall Lawns", category: "Eats & Stalls", desc: "Food stalls, house merchandise and the Founder's Day flea market come alive on the lawns." },
  { id: "d2-1", day: "2", time: "09:30 AM", title: "R.L. Holdsworth Memorial Cricket Match", venue: "Skinners Field", category: "Sports", desc: "The traditional Founder's Day fixture — the School XI takes on the Old Boys' XI at Skinners." },
  { id: "d2-2", day: "2", time: "11:30 AM", title: "The Chandbagh Debates", venue: "BML Munjal Auditorium", category: "Cultural & Plays", desc: "School teams and visiting speakers clash over the motion of the year, in front of a full house." },
  { id: "d2-3", day: "2", time: "01:00 PM", title: "DSOBS Lunch & AGM Registration", venue: "Kilachand Library", category: "Old Boys (DSOBS)", desc: "Old Boys gather over lunch ahead of the AGM — batch photographs on the library steps." },
  { id: "d2-4", day: "2", time: "03:00 PM", title: "Archives Exhibition — 91 Years Through the Lens", venue: "Kilachand Library", category: "Exhibitions", desc: "Rare photographs, letters and Founder's Day programmes from nine decades of school archives." },
  { id: "d2-5", day: "2", time: "06:30 PM", title: "The Founder's Play", venue: "Rose Bowl Amphitheatre", category: "Cultural & Plays", desc: "The centrepiece of the weekend — the Founder's Play staged under the open sky of the Rose Bowl." },
  { id: "d3-1", day: "3", time: "10:00 AM", title: "Pagal Gymkhana — Oberoi House Fete", venue: "Oberoi House", category: "Eats & Stalls", desc: "The gloriously chaotic house fete: games, eats, music and the entire school let off steam." },
  { id: "d3-2", day: "3", time: "12:00 PM", title: "DSOBS Annual General Meeting", venue: "BML Munjal Auditorium", category: "Old Boys (DSOBS)", desc: "The Doon School Old Boys' Society meets — reports, elections and the state of the Doon family." },
  { id: "d3-3", day: "3", time: "02:00 PM", title: "Music Programme", venue: "Rose Bowl Amphitheatre", category: "Cultural & Plays", desc: "The school orchestra and choir perform in the Bowl — the musical heart of Founder's Day." },
  { id: "d3-4", day: "3", time: "04:00 PM", title: "Founder's Day Speeches & Prize Distribution", venue: "Main Building", category: "Cultural & Plays", desc: "The Chief Guest's address, house awards and the closing of the 91st Founder's Day." },
];

export const HOUSES = [
  {
    name: "Hyderabad", color: "#1E3A8A", on: "ivory", founded: "1935", tag: "The Blue House",
    spirit: "Warm, formidable and fiercely loyal — Hyderabad sets the standard for house spirit on Skinners Field.",
    known: ["Dominant on the athletics field", "Blue banners of the Chandbagh skyline", "A legendary inter-house rivalry"],
  },
  {
    name: "Jaipur", color: "#16A34A", on: "ivory", founded: "1935", tag: "The Green House",
    spirit: "Bold and passionate — Jaipur brings fire to every debate, stage and contest at Chandbagh.",
    known: ["Fearless in the debating hall", "A proud cricketing pedigree", "Heart of the Quad on Founder's Day"],
  },
  {
    name: "Kashmir", color: "#EAB308", on: "navy", founded: "1937", tag: "The Yellow House",
    spirit: "Calm, precise and unshakable — Kashmir wins with quiet excellence, on the field and off it.",
    known: ["Olympic gold with Abhinav Bindra", "Began life as Gibson House in 1937", "Water-tight defence in house matches"],
  },
  {
    name: "Oberoi", color: "#0EA5E9", on: "navy", founded: "1991", tag: "The Sky Blue House",
    spirit: "The youngest house in Chandbagh, carrying the newest energy into the oldest of traditions.",
    known: ["The fifth house, opened in 1991", "Home ground of Pagal Gymkhana", "Sky-blue colours of the Chandbagh skyline"],
  },
  {
    name: "Tata", color: "#DC2626", on: "ivory", founded: "1935", tag: "The Red House",
    spirit: "Steadfast and proud — Tata blends grit with grace across ninety-one years of Chandbagh lore.",
    known: ["One of the four founding houses", "Renowned for house productions", "A loyal legion of Old Boys"],
  },
  {
    name: "Foot", color: "#558F93", on: "ivory", founded: "", tag: "Holding House",
    spirit: "Named for Arthur E. Foot, Doon's first Headmaster — Foot House is where every new Dosco spends his first year, cared for before joining his house.",
    known: ["Holding house named after Arthur E. Foot", "Home of the new D-formers for year one", "Extra pastoral care before house life"],
  },
  {
    name: "Martyn", color: "#477164", on: "ivory", founded: "", tag: "Holding House",
    spirit: "Carrying the name of John A. K. Martyn, the second Headmaster — Martyn House readies Chandbagh's youngest for the five houses ahead.",
    known: ["Holding house named after J. A. K. Martyn", "One year of care before house life", "A schoolmaster of legends lent it his name"],
  },
];

export const VENUES = [
  { name: "Main Building", slug: "main-building", x: 50, y: 36, img: IMAGES.mainBuilding, blurb: "The red-brick heart of Chandbagh — assemblies, speeches and the Quad." },
  { name: "Rose Bowl Amphitheatre", slug: "rose-bowl", x: 26, y: 60, img: IMAGES.roseBowl, blurb: "Open-air amphitheatre hosting the Founder's Play and the music programme." },
  { name: "BML Munjal Auditorium", slug: "bml-munjal-auditorium", x: 72, y: 55, img: IMAGES.auditorium, blurb: "The modern auditorium — home of the Chandbagh Debates and the DSOBS AGM." },
  { name: "Skinners Field", slug: "skinners-field", x: 30, y: 84, img: IMAGES.skinners, blurb: "The main ground — athletics finals and the R.L. Holdsworth cricket match." },
  { name: "Kilachand Library", slug: "kilachand-library", x: 58, y: 72, img: IMAGES.library, blurb: "The school's literary heart — exhibitions and the archives display." },
  { name: "Art School", slug: "art-school", x: 78, y: 28, img: IMAGES.artSchool, blurb: "Studios and galleries opening their doors for Founder's Day." },
];

export const QUIZ = [
  {
    q: "Who founded The Doon School in 1935?",
    options: ["Satish Ranjan Das", "Jawaharlal Nehru", "Arthur E. Foot", "Lord Mountbatten"],
    answer: 0,
    fact: "S.R. Das dreamed of an all-India school; his vision opened in the Doon valley in September 1935.",
  },
  {
    q: "What is the school motto?",
    options: ["Play the Game", "Knowledge Our Light", "Light Our Knowledge", "Service Before Self"],
    answer: 1,
    fact: "'Knowledge Our Light' — the motto has guided ninety-one Founder's Days at Chandbagh.",
  },
  {
    q: "Which iconic open-air venue hosts the Founder's Play?",
    options: ["The Rose Bowl", "Skinners Field", "The Quad", "BML Munjal Auditorium"],
    answer: 0,
    fact: "The Rose Bowl amphitheatre, carved into a natural hollow, has staged the Founder's Play for decades.",
  },
  {
    q: "Which Dosco won India's first individual Olympic gold medal?",
    options: ["Rahul Dravid", "Abhinav Bindra", "Jaspal Rana", "Milkha Singh"],
    answer: 1,
    fact: "Shooter Abhinav Bindra, a Kashmir House Dosco, won gold at the 2008 Beijing Olympics.",
  },
  {
    q: "Which house joined the original four as Doon's fifth house in 1991?",
    options: ["Oberoi House", "Tata House", "Hyderabad House", "Jaipur House"],
    answer: 0,
    fact: "Oberoi House opened in 1991, during Headmaster Shomie Das's tenure, joining Hyderabad, Jaipur, Kashmir and Tata.",
  },
];

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
